import { render, staticRenderFns } from "./taxesInfo.vue?vue&type=template&id=ea963144"
import script from "./taxesInfo.vue?vue&type=script&lang=js"
export * from "./taxesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports